export const validatePhoneNumber = (number?: string | null): boolean => {
  if (!number || number === null) return false
  return number.replace(/\D/g, '').length === 10
}

export const validateConfirmationCode = (number?: string | null): boolean => {
  if (!number || number === null) return false
  return number.replace(/\D/g, '').length === 4
}
